import React, { useEffect, useState } from "react";
import {
    Box,
    Button,
    TextField,
    Typography,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Autocomplete,
    Stack,
    IconButton,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { DataGrid } from "@mui/x-data-grid";
import ToastMsg from "../../../Components/ToastMsg/ToastMsg";
import RestAPIService from "../../../Utility/Services/RestAPIService";
import { Serviceurls } from "../../../Utility/API/Serviceurls";
import { useHistory } from 'react-router-dom'
import { useLocation } from 'react-router-dom'
import { CommonDeleteButton, CommonEditButton } from "../../../Components/Common Components/CommonComponents";
import { ImagePaths } from "../../../Utility/ImagePaths";
import CommonValidation from "../../../Components/CommonFunctions/CommonValidation";
import Loader from "../../../Components/Loader";
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { set } from "date-fns";
import { ContentInTooltip, GetStoreBaseUrl } from "../../../Components/CommonFunctions/CommonFunctions";
import { DateTime } from "luxon";
import { Colors } from "../../../Styles/Colors";


const StoreIndentRiseAdd = ({ forIndentReceive, loggedData, }) => {
    const history = useHistory();
    const location = useLocation();
    const [expanded, setExpanded] = useState(false);
    const [isloader, setisloader] = useState(false);
    const [forRaiseRequest, setForRaiseRequest] = useState(location.states?.for_raise_request || false);
    const [forTransfer, setForTransfer] = useState(location.states?.for_transfer || false);
    const [forSendProduct, setforSendProduct] = useState(location.states?.for_send_product || false);
    const [forViewOnly, setForViewOnly] = useState(location.states?.for_view_only || false);
    const [forReturn, setforReturn] = useState(location.states?.forReturn || false);
    const [fromWantedList, setfromWantedList] = useState(location.states?.from_wanted_list || false);
    const [categoryList, setcategoryList] = useState([]);
    const [vendorMappList, setvendorMappList] = useState([]);
    const [subLocationList, setSubLocationList] = useState([]);
    const [subCategoryList, setsubCategoryList] = useState([]);
    const [departmentList, setdepartmentList] = useState([]);
    const [productTypeList, setProductTypeList] = useState([]);
    const [productList, setProductList] = useState([]);
    const [errorMsg, seterrorMsg] = useState(false);
    const [errorMsgText, seterrorMsgText] = useState('');
    const [successMsg, setsuccessMsg] = useState(false);
    const [successMsgText, setsuccessMsgText] = useState('');
    const [IndentDataList, setIndentDataList] = useState([]);
    const [DeletedLineItmIds, setDeletedLineItmIds] = useState([]);
    const [EditID, setEditID] = useState(null);
    const [RequestEditID, setRequestEditID] = useState(null);
    const [RequestItemId, setRequestItemId] = useState(null);
    const [fromSublocation, setFromSublocation] = useState(null);
    const [TosubLocation, setTosubLocation] = useState(null);
    const [gst, setgst] = useState('');
    const [postBtnDisble, setPostBtnDisble] = useState(false);
    const [formData, setFormData] = useState({
        product_details: null,
        department_details: null,
        category_details: null,
        sub_category_details: null,
        product_type_details: null,
        modelSerialNo: "",
        hsnCode: "",
        quantity: "",
        available_batch_list: [],
        selected_batch_list: [],
        batch_no: "",
        batch_quantity: "",
        total_tranfer_quantity: 0
    });

    useEffect(() => {
        if (postBtnDisble) {
            if (postBtnDisble === "transfer") {
                PostTransferIndent()
            } else {
                PostRiseRequest()
            }
        }
    }, [postBtnDisble])

    const columns = [
        {
            field: "product_name", headerName: "Product Details", flex: 0.15,
            renderCell: (params) => (
                <Box component={'div'} emed_tid='emed_lab_rcpt_dtls'>
                    {ContentInTooltip(params?.row?.product_name, 40, "0.8vw", 600)}
                    {ContentInTooltip(params?.row?.product_code, 40, "0.7vw", 500, 0, Colors.grayShade)}
                </Box>)
        },
        { field: "department_name", headerName: "Department", flex: 0.1 },
        { field: "category_name", headerName: "Category", flex: 0.1 },
        { field: "sub_category_name", headerName: "Sub Category", flex: 0.1 },
        { field: "product_type_name", headerName: "Product Type", flex: 0.1 },
        { field: "modelSerialNo", headerName: "Model/Serial No", flex: 0.1 },
        { field: "hsnCode", headerName: "HSN Code", flex: 0.1 },
        {
            field: "quantity", headerName: "Quantity", flex: 0.1, renderCell: (params) => {
                let QuantityData = params?.row?.approved_quantity || params?.row?.transfer_quantity || params?.row?.received_quantity || params?.row?.request_quantity || params?.row?.quantity
                return (
                    <Box component={'div'}>
                        {forViewOnly ? QuantityData : forTransfer ? `${params.row?.total_tranfer_quantity || 0} / ${params.row?.quantity || 0}` : (forSendProduct || forReturn) ? `${params.row?.total_tranfer_quantity || 0}` : `${params.row?.quantity || 0}`}
                    </Box>
                )
            }
        },
        {
            field: "action", headerName: "Action", flex: 0.15,
            renderCell: (params) => (
                <Stack direction="row" alignItems="center" spacing={4}>
                    <Stack direction="row" justifyContent="space-evenly" alignItems="center" spacing={1} visibility={forViewOnly ? "hidden" : "visible"}>
                        {
                            (forTransfer || forSendProduct || forReturn) ?
                                <>
                                    <Button
                                        startIcon={<AddCircleIcon />}
                                        sx={{ textTransform: "capitalize" }}
                                        onClick={() => {
                                            if (params.row.available_batch_list?.length) {
                                                let ProductData = productList?.find((item) => item?.id === (params.row.productID || params.row.product_id))
                                                setFormData({
                                                    product_details: ProductData,
                                                    department_details: params.row?.department_name,
                                                    category_details: params.row?.category_name,
                                                    sub_category_details: params.row?.sub_category_name,
                                                    product_type_details: params.row?.product_type_name,
                                                    modelSerialNo: ProductData?.model_no ? ProductData?.model_no : "",
                                                    hsnCode: ProductData?.hsn_code ? ProductData?.hsn_code : "",
                                                    quantity: params.row.quantity ? params.row.quantity : "",
                                                    id: params.row.id ? params.row.id : null,
                                                    available_batch_list: params.row.available_batch_list ? params.row.available_batch_list : [],
                                                    selected_batch_list: params.row.selected_batch_list ? params.row.selected_batch_list : [],
                                                    request_quantity: params.row.request_quantity ? params.row.request_quantity : "",
                                                    approved_quantity: params.row.approved_quantity ? params.row.approved_quantity : "",
                                                    total_tranfer_quantity: params.row.total_tranfer_quantity ? params.row.total_tranfer_quantity : "",
                                                });
                                                setRequestItemId(params?.id ? (params?.id - 1) : null)
                                                setExpanded(true)
                                            } else {
                                                errorMessage("No Stock available !")
                                            }

                                        }}>{params.row?.total_tranfer_quantity ? "Edit Batch" : "Add Batch"}</Button>
                                    {(forSendProduct || forReturn) ?
                                        <CommonDeleteButton size="1.5vw" onClick={() => {
                                            let DataList = [...IndentDataList]
                                            DataList.splice(params.api.getRowIndex(params.id), 1)
                                            if (params.row.id) {
                                                let DeletedLineIds = DeletedLineItmIds
                                                DeletedLineIds.push(params.row.id)
                                                setDeletedLineItmIds(DeletedLineIds)
                                            }
                                            setIndentDataList(DataList)
                                        }} /> : null
                                    }
                                </> :
                                <>
                                    <CommonEditButton size="1.5vw" onClick={() => {
                                        let ProductData = productList?.find((item) => item?.id === (params.row.productID || params.row.product_id))
                                        setFormData({
                                            product_details: ProductData,
                                            department_details: params.row?.department_name,
                                            category_details: params.row?.category_name,
                                            sub_category_details: params.row?.sub_category_name,
                                            product_type_details: params.row?.product_type_name,
                                            modelSerialNo: ProductData?.model_no ? ProductData?.model_no : "",
                                            hsnCode: ProductData?.hsn_code ? ProductData?.hsn_code : "",
                                            quantity: params.row.quantity ? params.row.quantity : "",
                                            id: params.row.id ? params.row.id : null,
                                        });
                                        setRequestItemId(params?.id ? (params?.id - 1) : null)
                                        setExpanded(true)
                                    }} />
                                    <CommonDeleteButton size="1.5vw" onClick={() => {
                                        let DataList = [...IndentDataList]
                                        DataList.splice(params.api.getRowIndex(params.id), 1)
                                        if (params.row.id) {
                                            let DeletedLineIds = DeletedLineItmIds
                                            DeletedLineIds.push(params.row.id)
                                            setDeletedLineItmIds(DeletedLineIds)
                                        }
                                        setIndentDataList(DataList)
                                    }} />
                                </>
                        }

                    </Stack>
                </Stack>)
        },
    ];

    useEffect(() => {
        if (!forViewOnly) {
            getSubCategoryList()
            getCategoryList()
            getdepartmentList()
            getProductType()
        }

        if (!forRaiseRequest) {
            getProductList(location.states?.line_items ? location.states.line_items : null)
        }
        if (forTransfer || forViewOnly) {
            setFromSublocation(location?.states?.indent_data?.from_location)
            setTosubLocation(location?.states?.indent_data?.to_location)
        } else {
            if (loggedData?.module_name === "store_module") {
                setFromSublocation({ id: loggedData?.store_id, sublocation_name: loggedData?.store_name })
                getSubLocationList()
            } else if (forSendProduct) {
                setFromSublocation({ id: loggedData?.sublocation_id, sublocation_name: loggedData?.sublocation_name })
                getSubLocationList()
            } else {
                setFromSublocation({ id: loggedData?.sublocation_id, sublocation_name: loggedData?.sublocation_name })
                getSubLocationList({ id: loggedData?.store_id, sublocation_name: loggedData?.store_name, is_main_store: true })
            }
        }

    }, [])

    const msgClose = () => {
        seterrorMsg(false);
        seterrorMsgText('');
        setsuccessMsg(false);
        setsuccessMsgText('');
    }

    const errorMessage = (msg) => {
        setisloader(false)
        setPostBtnDisble(false)
        seterrorMsgText(msg)
        seterrorMsg(true)
    }

    const successMessage = (msg) => {
        setisloader(false)
        setPostBtnDisble(false)
        setsuccessMsgText(msg)
        setsuccessMsg(true)
    }

    const getSubLocationList = (storeObj = null) => {
        try {
            RestAPIService.getAll(Serviceurls.SUB_LOCATION_CREATION_MASTER + '?only_store=true')
                .then((response) => {
                    if (response.data.status === 'success') {
                        let List = []
                        if (storeObj) {
                            List = [...response.data.data?.filter((item) => item?.is_active), storeObj] || []
                        } else {
                            List = response.data.data?.filter((item) => item?.is_active) || []
                        }
                        if (loggedData?.module_name === "store_module") {
                            setSubLocationList(List)
                        } else {
                            setSubLocationList(List?.filter((item) => item?.id !== loggedData?.sublocation_id) || [])
                        }
                    }
                }).catch(e => {
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            errorMessage(e.message)
        }
    }

    const getCategoryList = () => {
        try {
            RestAPIService.getAll(Serviceurls.STORE_CATEGORY)
                .then((response) => {
                    if (response.data.status === 'success') {
                        setcategoryList(response.data.data?.filter((item) => item?.is_active) || [])
                    }
                }).catch(e => {
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            errorMessage(e.message)
        }
    }

    const getdepartmentList = () => {
        try {
            RestAPIService.getAll(Serviceurls.STORE_DEPARTMENT)
                .then((response) => {
                    if (response.data.status === 'success') {
                        setdepartmentList(response.data.data?.filter((item) => item?.is_active) || [])
                    }
                }).catch(e => {
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            errorMessage(e.message)
        }
    }

    const getSubCategoryList = () => {
        try {
            RestAPIService.getAll(Serviceurls.STORE_SUB_CATEGORY)
                .then((response) => {
                    if (response.data.status === 'success') {
                        setsubCategoryList(response.data.data?.filter((item) => item?.is_active) || [])
                    }
                }).catch(e => {
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            errorMessage(e.message)
        }
    }

    const getProductType = () => {
        try {
            RestAPIService.getAll(Serviceurls.STORE_PRODUCT_TYPE)
                .then((response) => {
                    if (response.data.status === 'success') {
                        setProductTypeList(response.data.data?.filter((item) => item?.is_active) || [])
                    }
                }).catch(e => {
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            errorMessage(e.message)
        }
    }

    const getProductList = (LineItems = [], ToLoc = null) => {
        try {
            setisloader(true)
            let Params = ""
            if (forRaiseRequest) {
                if (ToLoc?.is_main_store) {
                    Params = "?to_store_id=" + ToLoc?.id
                } else {
                    Params = "?to_sublocation_id=" + ToLoc?.id
                }
            } else if (forTransfer || forSendProduct || forReturn) {
                if (loggedData?.module_name === "store_module") {
                    Params = "?to_store_id=" + loggedData?.store_id || null
                } else {
                    Params = "?to_sublocation_id=" + loggedData?.sublocation_id || null
                }
            }
            RestAPIService.getAll(Serviceurls.STORE_SUBLOC_PRODUCT_LIST + Params)
                .then((response) => {
                    if (response.data.status === 'success') {
                        let List = (response.data?.data || [])
                            // .filter(item => item?.is_active)
                            .map(item => ({
                                ...item,
                                display_key: `${item.product_name} | ${item.product_code} | ${item.department_name} | ${item.category_name} | ${item.sub_category_name} | ${item.product_type_name}`
                            }));
                        setProductList(List)
                        if (response.data?.data?.length === 0) {
                            if (forRaiseRequest || fromWantedList) {
                                errorMessage(`No stock availble in ${TosubLocation?.sublocation_name || ""}`)
                            }
                        }
                        if (LineItems?.length) {
                            let data = LineItems?.filter((item) => item?.transfer_status !== "Cancelled")
                            let ReqLineItems = []
                            data?.forEach((list) => {
                                let ProductDetails = response.data.data?.find((item) => list?.product_id === item?.id)
                                ReqLineItems?.push({
                                    product_id: ProductDetails?.id,
                                    product_name: ProductDetails?.product_name || list?.product_name,
                                    product_code: ProductDetails?.product_code || list?.product_code,
                                    product_details: ProductDetails,
                                    department_name: ProductDetails?.department_name || list?.department_name,
                                    category_name: ProductDetails?.category_name || list?.category_name,
                                    sub_category_name: ProductDetails?.sub_category_name || list?.sub_category_name,
                                    product_type_name: ProductDetails?.product_type_name || list?.product_type_name,
                                    modelSerialNo: ProductDetails?.model_no || list?.model_no,
                                    hsnCode: ProductDetails?.hsn_code || list?.hsn_code,
                                    quantity: +list?.approved_quantity || +list?.quantity || 0,
                                    approved_quantity: +list?.approved_quantity || 0,
                                    request_quantity: +list?.request_quantity || 0,
                                    transfer_quantity: +list?.transfer_quantity || 0,
                                    received_quantity: +list?.received_quantity || 0,
                                    id: list?.id
                                })
                            })
                            if (forTransfer) {
                                getProductBatchDetails(ReqLineItems)
                            } else {
                                setisloader(false)
                                setIndentDataList(ReqLineItems)
                            }
                        } else {
                            setisloader(false)
                        }
                    }
                }).catch(e => {
                    setisloader(false)
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            errorMessage(e.message)
        }
    }

    const getProductBatchDetails = (LineItems, forSingle = false) => {
        try {
            RestAPIService.getAll(Serviceurls.STORE_BATCH_DETAILS_LIST + `?product_id=${LineItems?.map((product => product.product_id))}`)
                .then((response) => {
                    if (response.data.status === 'success') {
                        let NewData = LineItems?.map((product) => ({
                            ...product,
                            available_batch_list: response?.data?.data[product?.product_id],
                        }))
                        setisloader(false)
                        if (forSingle) {
                            setFormData((prev) => ({
                                ...prev,
                                available_batch_list: response?.data?.data[LineItems[0]?.product_id],
                            }))
                            if (!response?.data?.data[LineItems[0]?.product_id]) {
                                errorMessage("No stock Available !")
                            }
                        } else {
                            setIndentDataList(NewData || []);
                        }
                    }
                }).catch(e => {
                    setisloader(false)
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            errorMessage(e.message)
        }
    }

    const PostRiseRequest = () => {
        try {
            // if (!productType) {
            //     errorMessage('Please Enter Product Type')
            // } else {
            let LineItems = []
            IndentDataList?.forEach((list) => {
                LineItems.push({
                    'product_id': list?.product_id,
                    'request_quantity': +list?.quantity,
                    'id': list?.id || null,
                    'approved_quantity': 0,
                    'transfer_quantity': 0,
                    'received_quantity': 0,
                    'is_approved': false
                })
            })
            const current_datetime = `${DateTime.fromJSDate(new Date()).toFormat("yyyy-MM-dd")} ${DateTime.fromJSDate(new Date()).toLocaleString(DateTime.TIME_24_SIMPLE)}:00`

            let data = {
                'transfer_type': 'Inbound',
                'status': 'Initiated',
                'indent_date': current_datetime,
                'transfer_date': current_datetime,
                'from_store_id': null,
                'to_store_id': null,
                'from_sub_location_id': null,
                'to_sub_location_id': null,
                'indent_lines': LineItems

            }
            if (loggedData?.module_name === "store_module") {
                data['from_store_id'] = fromSublocation?.id || null
            } else {
                data['from_sub_location_id'] = fromSublocation?.id || null
            }

            if (TosubLocation?.is_main_store) {
                data['to_store_id'] = TosubLocation?.id || null
            } else {
                data['to_sub_location_id'] = TosubLocation?.id || null
            }

            if (EditID) {
                data["inward_id"] = EditID
                data["request_id"] = RequestEditID
                data["ids_deleted"] = DeletedLineItmIds
                setisloader(true)
                RestAPIService.updateWithOutId(data, Serviceurls.STORE_STOCK_TRANSFER)
                    .then((response) => {
                        if (response.data.status === 'success') {
                            let EndPointUrl = ""
                            if (forTransfer) {
                                EndPointUrl = `IndentReceive`
                            } else if (forReturn) {
                                EndPointUrl = `ReturnRequest`
                            } else {
                                EndPointUrl = `IndentRise`
                            }
                            history.push({ pathname: `${GetStoreBaseUrl()}/${EndPointUrl}`, states: { success_message: response.data.message } })

                        }
                    }).catch(e => {
                        if (e?.response?.data?.status === 'fail') {
                            errorMessage(e.response.data.message)
                        } else {
                            errorMessage(e.message)
                        }
                    })
            } else {
                setisloader(true)
                RestAPIService.create(data, Serviceurls.STORE_STOCK_TRANSFER)
                    .then((response) => {
                        if (response.data.status === 'success') {
                            let EndPointUrl = ""
                            if (forTransfer) {
                                EndPointUrl = `IndentReceive`
                            } else if (forReturn) {
                                EndPointUrl = `ReturnRequest`
                            } else {
                                EndPointUrl = `IndentRise`
                            }
                            history.push({ pathname: `${GetStoreBaseUrl()}/${EndPointUrl}`, states: { success_message: response.data.message } })

                        }
                    }).catch(e => {
                        if (e?.response?.data?.status === 'fail') {
                            errorMessage(e.response.data.message)
                        } else {
                            errorMessage(e.message)
                        }
                    })
            }
            // }
        } catch (e) {
            errorMessage(e.message)
        }
    }

    const PostTransferIndent = () => {
        try {
            // if (!productType) {
            //     errorMessage('Please Enter Product Type')
            // } else {
            let ReqLineItems = IndentDataList || []
            let IndentData = location?.states?.indent_data || {}
            let LineItems = []
            ReqLineItems?.forEach((list) => {
                let BatchDetails = []
                list?.selected_batch_list?.forEach((batch) => {
                    BatchDetails.push({
                        'batch_no': batch?.batch_no?.batch_no || "",
                        'expiry_date': batch?.batch_no?.expiry_date || null,
                        'product_id': batch?.batch_no?.product_id || null,
                        'mrp_per_quantity': batch?.batch_no?.mrp_per_quantity || 0,
                        'quantity': +batch?.batch_quantity || 0,
                    })
                })
                let TotalQuantity = BatchDetails?.reduce((sum, item) => sum + item?.quantity, 0)
                LineItems.push({
                    'request_quantity': (forSendProduct ? TotalQuantity : +list?.request_quantity) || 0,
                    'id': list?.id || null,
                    'approved_quantity': (forSendProduct ? TotalQuantity : +list?.approved_quantity) || 0,
                    'transfer_quantity': TotalQuantity,
                    'received_quantity': 0,
                    'batch_details': BatchDetails,
                    'product_id': list?.product_id || null,
                    'is_approved': true
                })
            })
            const current_datetime = `${DateTime.fromJSDate(new Date()).toFormat("yyyy-MM-dd")} ${DateTime.fromJSDate(new Date()).toLocaleString(DateTime.TIME_24_SIMPLE)}:00`

            let data = {
                'indent_id': IndentData?.id || null,
                'status': "Transferred",
                'indent_date': current_datetime,
                'line_cancel_ids': null,
                'indent_lines': LineItems
            }
            if (forSendProduct) {
                data['transfer_type'] = "Outbound"
                data['transfer_date'] = current_datetime
            }
            if (forReturn) {
                data['transfer_type'] = "Return"
                data['transfer_date'] = current_datetime
            }
            if (loggedData?.module_name === "store_module") {
                data['from_store_id'] = fromSublocation?.id || null
            } else {
                data['from_sub_location_id'] = fromSublocation?.id || null
            }

            if (TosubLocation?.is_main_store) {
                data['to_store_id'] = TosubLocation?.id || null
            } else {
                data['to_sub_location_id'] = TosubLocation?.id || null
            }
            setisloader(true)
            RestAPIService[forTransfer ? "updateWithOutId" : "create"](data, Serviceurls.STORE_STOCK_TRANSFER)
                .then((response) => {
                    if (response.data.status === 'success') {
                        let EndPointUrl = ""
                        if (forTransfer || forSendProduct) {
                            EndPointUrl = `IndentReceive`
                        } else if (forReturn) {
                            EndPointUrl = `ReturnRequest`
                        } else {
                            EndPointUrl = `IndentRise`
                        }
                        history.push({ pathname: `${GetStoreBaseUrl()}/${EndPointUrl}`, states: { success_message: response.data.message } })
                    }
                }).catch(e => {
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
            // }
        } catch (e) {
            errorMessage(e.message)
        }
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        switch (name) {
            case 'batch_quantity':
            case 'quantity':
                if (CommonValidation.numberOnly(value) && (+value >= 0) || value === "") {
                    setFormData((prev) => ({ ...prev, [name]: value }));
                }
                break;
            default:
                setFormData((prev) => ({ ...prev, [name]: value }));
        }
    }

    const rendertable = () => {
        IndentDataList?.forEach((element, index) => element.sno = index + 1)
        return (
            <DataGrid
                rows={IndentDataList}
                columns={columns}
                getRowId={(row) => row['sno']}
                hideFooter
                density="compact" />
        )
    }

    return (
        <Box sx={{}}>
            <Box component={'div'} className='eMed_Pharma_Header_Card' sx={{ display: "flex", justifyContent: 'space-between', alignItems: 'center', height: "7dvh" }}>
                <Stack direction="row" spacing={1} alignItems="center">
                    <IconButton size="small" onClick={() => {
                        history.push({ pathname: forViewOnly ? location.states?.return_path : fromWantedList ? `${GetStoreBaseUrl()}/WantedList` : forReturn ? `${GetStoreBaseUrl()}/ReturnRequest` : (forIndentReceive || forSendProduct) ? `${GetStoreBaseUrl()}/IndentReceive` : `${GetStoreBaseUrl()}/IndentRise` })
                    }} >
                        <img className="emedhub_popupIcon_img" src={ImagePaths.LabBackButton.default} alt={"Back"} />
                    </IconButton>
                    <Typography sx={{ color: "#616161" }}> {`Back to ${location.states?.return_screen ? location.states?.return_screen : fromWantedList ? "Wanted List" : forReturn ? "Return Request" : (forIndentReceive || location.states?.viewFromOutbound) ? "Outbound" : "Inbound"} Home`}</Typography></Stack>
                <Button sx={{ textTransform: 'capitalize', visibility: forViewOnly ? "hidden" : "visible" }}
                    size="small"
                    variant="contained"
                    disabled={postBtnDisble}
                    onClick={() => {
                        if ((forTransfer || forSendProduct || forReturn)) {
                            if (!TosubLocation?.id && !forTransfer) {
                                errorMessage("Select the To Location")
                            } else if (IndentDataList?.every((item) => ((item?.total_tranfer_quantity || 0) === 0))) {
                                errorMessage("Add the Batch details")
                            } else {
                                setPostBtnDisble("transfer")
                            }
                        } else {
                            if (!TosubLocation?.id) {
                                errorMessage("Select the To Location")
                            } else if (IndentDataList?.length === 0) {
                                errorMessage("Add the Product")
                            } else {
                                setPostBtnDisble(true)
                            }
                        }
                    }}>{(forTransfer || forSendProduct) ? "Transfer Product" : "Raise Request"}</Button>
            </Box>
            {/* Vendor Details */}
            <Box sx={{ height: '78dvh', overflow: 'auto' }}>
                <Box sx={{ margin: '0.5vw' }}>
                    <Box sx={{ display: "flex", alignItems: 'center' }}>
                        <Typography fontSize={"1vw"} gutterBottom sx={{ marginLeft: '0.5vw', marginRight: '1.5vw' }}>
                            Sub Location Details
                        </Typography>
                        <Autocomplete
                            options={subLocationList}
                            value={fromSublocation}
                            disabled
                            getOptionLabel={(option) => (typeof (option) === "string" ? option : `${option?.sublocation_name}`)}
                            onChange={(event, newValue) => {
                                setFromSublocation(newValue)
                            }}
                            renderInput={(params) => <TextField disabled {...params} label="From Location" variant="outlined" size="small" sx={{ width: "20dvw", marginRight: "1vw" }} />}
                        />
                        <Autocomplete
                            options={subLocationList}
                            value={TosubLocation}
                            disabled={forTransfer || forViewOnly}
                            getOptionLabel={(option) => (typeof (option) === "string" ? option : `${option?.sublocation_name}`)}
                            onChange={(event, newValue) => {
                                if (newValue?.id === fromSublocation?.id) {
                                    errorMessage("From and To Location should not be same")
                                } else {
                                    setTosubLocation(newValue)
                                    if (newValue) {
                                        getProductList([], newValue)
                                    } else {
                                        if (forRaiseRequest || fromWantedList) {
                                            setIndentDataList([])
                                            setExpanded(false)
                                            setFormData({
                                                product_details: null,
                                                department_details: null,
                                                category_details: null,
                                                sub_category_details: null,
                                                product_type_details: null,
                                                modelSerialNo: "",
                                                hsnCode: "",
                                                quantity: "",
                                                available_batch_list: [],
                                                selected_batch_list: [],
                                                batch_no: "",
                                                batch_quantity: "",
                                                total_tranfer_quantity: 0
                                            })
                                        }
                                    }
                                }
                            }}
                            renderInput={(params) => <TextField {...params} label="To Location *" variant="outlined" size="small" sx={{ width: "20dvw", marginRight: "1vw" }} />}
                        />
                    </Box>
                </Box>

                {/* Product Details Accordion */}
                <Accordion expanded={expanded} disabled={(forRaiseRequest || fromWantedList) && TosubLocation === null} onChange={() => setExpanded(!expanded)} sx={{ display: forViewOnly ? 'none' : "block" }}>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                        <Typography fontSize={"1vw"}>Product Details</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Box sx={{ display: "flex", flexWrap: 'wrap', alignItems: 'center' }}>
                            <Autocomplete
                                options={productList}
                                value={formData.product_details}
                                disabled={forTransfer}
                                getOptionLabel={(option) => typeof (option) === 'string' ? option : option.display_key}
                                onChange={(event, newValue) => {
                                    if (newValue) {
                                        setFormData((prev) => ({
                                            ...prev,
                                            product_details: newValue,
                                            department_details: newValue?.department_name,
                                            category_details: newValue?.category_name,
                                            sub_category_details: newValue?.sub_category_name,
                                            product_type_details: newValue?.product_type_name,
                                            modelSerialNo: newValue?.model_no ? newValue?.model_no : "",
                                            hsnCode: newValue?.hsn_code ? newValue?.hsn_code : "",
                                        }))
                                        if ((forTransfer || forSendProduct || forReturn)) {
                                            getProductBatchDetails([{ "product_id": newValue?.id }], true)
                                        }
                                    } else {
                                        setFormData({
                                            product_details: null,
                                            department_details: null,
                                            category_details: null,
                                            sub_category_details: null,
                                            product_type_details: null,
                                            modelSerialNo: "",
                                            hsnCode: "",
                                            quantity: "",
                                            selected_batch_list: [],
                                            available_batch_list: [],
                                        })
                                    }
                                }}
                                renderInput={(params) => <TextField {...params} label="Search Product" variant="outlined" size="small" sx={{ width: "41dvw", margin: "0.5vw" }} />}
                                renderOption={(props, item) => {
                                    if (typeof (item) === 'object') {
                                        return (
                                            <Box {...props}>
                                                <Box sx={{ display: 'flex', flexDirection: 'column', alignContent: "flex-start" }}>
                                                    <Box sx={{ display: 'flex', flexDirection: "row", alignItems: "center" }}>{ContentInTooltip(item?.product_name, 30, "0.9vw", 600, "0.5vw")} - {ContentInTooltip(item?.product_code, 30, "0.9vw", 500, "0.5vw")} </Box>
                                                    <Box sx={{ display: 'flex', flexDirection: "row", alignItems: "center" }}>{ContentInTooltip(item?.department_name, 30, "0.9vw", 500, "0.5vw")} - {ContentInTooltip(item?.category_name, 30, "0.9vw", 500, "0.5vw")} - {ContentInTooltip(item?.sub_category_name, 30, "0.9vw", 500, "0.3vw")}</Box>
                                                </Box>
                                            </Box>
                                        );
                                    }
                                    return <li {...props}>{typeof (item) === 'string' ? item : item?.product_name}</li>;
                                }}
                            />
                            <Autocomplete
                                options={departmentList}
                                disabled
                                value={formData.department_details}
                                getOptionLabel={(option) => typeof (option) === 'string' ? option : option.department_name}
                                onChange={(event, newValue) => setFormData((prev) => ({ ...prev, department_details: newValue }))}
                                renderInput={(params) => <TextField {...params} disabled label="Department" variant="outlined" size="small" sx={{ width: "20dvw", margin: "0.5vw" }} />}
                            />
                            <Autocomplete
                                disabled
                                options={categoryList}
                                value={formData.category_details}
                                getOptionLabel={(option) => typeof (option) === 'string' ? option : option.category_name}
                                onChange={(event, newValue) => setFormData((prev) => ({ ...prev, category_details: newValue }))}
                                renderInput={(params) => <TextField {...params} disabled label="Category" variant="outlined" size="small" sx={{ width: "20dvw", margin: "0.5vw" }} />}
                            />
                            <Autocomplete
                                disabled
                                options={subCategoryList}
                                value={formData.sub_category_details}
                                getOptionLabel={(option) => typeof (option) === 'string' ? option : option.sub_category_name}
                                onChange={(event, newValue) => setFormData((prev) => ({ ...prev, sub_category_details: newValue }))}
                                renderInput={(params) => <TextField {...params} disabled label="Sub Category" variant="outlined" size="small" sx={{ width: "20dvw", margin: "0.5vw" }} />}
                            />
                            <Autocomplete
                                disabled
                                options={productTypeList}
                                value={formData.product_type_details}
                                getOptionLabel={(option) => typeof (option) === 'string' ? option : option.product_type_name}
                                onChange={(event, newValue) => setFormData((prev) => ({ ...prev, product_type_details: newValue }))}
                                renderInput={(params) => <TextField {...params} disabled label="Product Type" variant="outlined" size="small" sx={{ width: "20dvw", margin: "0.5vw" }} />}
                            />
                            <TextField label="Product Code" name="productDetails" disabled value={formData?.product_details?.product_code ? formData?.product_details?.product_code : ""} onChange={handleChange} variant="outlined" size="small" sx={{ width: "20dvw", margin: "0.5vw" }} />
                            <TextField label="Model/Serial No" name="modelSerialNo" disabled value={formData.modelSerialNo} onChange={handleChange} variant="outlined" size="small" sx={{ width: "20dvw", margin: "0.5vw" }} />
                            <TextField label="HSN Code" name="hsnCode" disabled value={formData.hsnCode} onChange={handleChange} variant="outlined" size="small" sx={{ width: "20dvw", margin: "0.5vw" }} />
                            {(forTransfer || forSendProduct || forReturn) ? null : <TextField label="Quantity *" inputProps={{ maxLength: 5 }} disabled={forTransfer || forSendProduct || forReturn} name="quantity" value={formData.quantity} onChange={handleChange} variant="outlined" size="small" sx={{ width: "20dvw", margin: "0.5vw", visibility: (forTransfer || forSendProduct || forReturn) ? 'hidden' : "visible" }} />}
                            {
                                (formData?.available_batch_list?.length && (forTransfer || forSendProduct || forReturn)) ?
                                    <Box sx={{ display: 'block', marginTop: "0.5vw", width: '100%', padding: '0.5vw' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', marginTop: "0.5vw" }}>
                                            <Typography fontWeight={600} fontSize={"1vw"} marginRight={"1.5vw"}>{`Add Batch Details`}</Typography>
                                            <FormControl size="small" sx={{ width: '15vw' }}>
                                                <Select
                                                    value={formData?.batch_no || null}
                                                    MenuProps={{
                                                        style: { maxHeight: 300, maxWidth: 150 }
                                                    }}
                                                    onChange={(e) => {
                                                        setFormData((prev) => ({ ...prev, batch_no: e.target?.value }));
                                                    }}
                                                >
                                                    {
                                                        formData?.available_batch_list?.map((list, index) => (
                                                            <MenuItem key={index} value={list}>
                                                                <Box sx={{ display: 'flex', flexDirection: 'column', alignContent: "flex-start" }}>
                                                                    {ContentInTooltip((list.batch_no || "-"), 25, "0.8vw", 500,)}
                                                                    {ContentInTooltip((`Stock Qty - ${list.stock_in_quantity || 0}`), 25, "0.8vw", 600,)}
                                                                </Box>
                                                            </MenuItem>
                                                        ))
                                                    }
                                                </Select>
                                            </FormControl>
                                            <TextField label="Batch Quantity *" inputProps={{ maxLength: 5 }} name="batch_quantity" value={formData.batch_quantity} onChange={handleChange} variant="outlined" size="small" sx={{ width: "10dvw", margin: "0.5vw" }} />
                                            <Button variant="contained" size="small" sx={{ textTransform: "capitalize", marginLeft: "1vw" }} onClick={() => {
                                                if (!formData?.batch_no) {
                                                    errorMessage("Select the Batch")
                                                } else if (!formData?.batch_quantity || formData?.batch_quantity === "0") {
                                                    errorMessage("Enter the Batch Quantity")
                                                } else if ((formData?.available_batch_list?.find((item) => item?.batch_no === formData?.batch_no?.batch_no)?.stock_in_quantity < +formData?.batch_quantity)) {
                                                    errorMessage("Batch quantity should not be greater than available stock. Avl Stock - (" + formData?.available_batch_list?.find((item) => item?.batch_no === formData?.batch_no?.batch_no)?.stock_in_quantity + ")")
                                                } else if (formData?.selected_batch_list?.some((item) => item?.batch_no?.batch_no === formData?.batch_no?.batch_no)) {
                                                    errorMessage("Batch Already added !")
                                                } else {
                                                    let TotalTransferQty = [...formData.selected_batch_list, { batch_no: formData?.batch_no, batch_quantity: +formData?.batch_quantity }]?.reduce((sum, item) => sum + item?.batch_quantity, 0)
                                                    if ((TotalTransferQty > formData?.quantity) && forTransfer) {
                                                        errorMessage("Total Transfer Quantity should not be greater than Approved Quantity. Approved Qty - (" + formData?.quantity + ")")
                                                    } else {
                                                        setFormData((prev) => ({
                                                            ...prev,
                                                            batch_no: null,
                                                            batch_quantity: "",
                                                            selected_batch_list: [...prev.selected_batch_list, { batch_no: formData?.batch_no, batch_quantity: +formData?.batch_quantity }],
                                                            total_tranfer_quantity: TotalTransferQty,
                                                        }))
                                                    }
                                                }
                                            }}>Add Batch</Button>
                                            <Button variant="outlined" size="small" sx={{ textTransform: "capitalize", marginLeft: "1vw" }} onClick={() => {
                                                setFormData((prev) => ({
                                                    ...prev,
                                                    batch_no: null,
                                                    batch_quantity: "",
                                                }))
                                            }}>Clear</Button>
                                        </Box>
                                        <Box sx={{ display: 'flex', alignItems: 'center', marginTop: "0.5vw", marginBottom: "0.5vw" }}>
                                            {
                                                formData?.selected_batch_list?.map((list, index) => (
                                                    <Box key={index} sx={{ display: 'flex', alignItems: 'center', marginTop: "0.5vw" }}>
                                                        <Typography>{`${list?.batch_no?.batch_no} | Qty - ${list?.batch_quantity}`}</Typography>
                                                        <CommonDeleteButton
                                                            size="1.2vw" onClick={() => {
                                                                let DataList = [...formData?.selected_batch_list]
                                                                DataList.splice(index, 1)
                                                                let TotalTransferQty = [...DataList]?.reduce((sum, item) => sum + item?.batch_quantity, 0)
                                                                setFormData((prev) => ({
                                                                    ...prev,
                                                                    selected_batch_list: DataList,
                                                                    total_tranfer_quantity: TotalTransferQty,
                                                                }))
                                                            }} />
                                                        <Typography marginRight={"1.5vw"}>{index === formData?.selected_batch_list?.length - 1 ? "" : ","}</Typography>
                                                    </Box>
                                                ))
                                            }
                                        </Box>

                                    </Box> : null
                            }
                            <Button sx={{ textTransform: 'capitalize' }} size="small" variant="outlined" onClick={() => {
                                setFormData({
                                    product_details: null,
                                    department_details: null,
                                    category_details: null,
                                    sub_category_details: null,
                                    product_type_details: null,
                                    modelSerialNo: "",
                                    hsnCode: "",
                                    quantity: "",
                                    selected_batch_list: [],
                                    available_batch_list: [],
                                });
                            }}>Clear</Button>
                            <Button sx={{ textTransform: 'capitalize', marginLeft: "0.5vw" }} size="small" variant="contained" onClick={() => {
                                if (!formData?.product_details) {
                                    errorMessage("Select the Product")
                                } else if (!formData?.quantity && !forSendProduct && !forReturn) {
                                    errorMessage("Enter the Quantity")
                                } else if (formData?.selected_batch_list?.length === 0 && (forSendProduct || forReturn)) {
                                    errorMessage("Add Batch details")
                                } else if (IndentDataList?.some((list, index) => (list?.product_id === formData?.product_details?.id && RequestItemId !== index))) {
                                    errorMessage(`${formData?.product_details?.product_name} Already added !`)
                                } else {
                                    let IndentData = {
                                        product_id: formData?.product_details?.id,
                                        product_name: formData?.product_details?.product_name,
                                        product_code: formData?.product_details?.product_code,
                                        product_details: formData?.product_details,
                                        department_name: formData?.department_details,
                                        category_name: formData?.category_details,
                                        sub_category_name: formData?.sub_category_details,
                                        product_type_name: formData?.product_type_details,
                                        modelSerialNo: formData?.modelSerialNo,
                                        hsnCode: formData?.hsnCode,
                                        quantity: +formData?.quantity,
                                        id: formData?.id || null,
                                        selected_batch_list: formData?.selected_batch_list || [],
                                        available_batch_list: formData?.available_batch_list || [],
                                        request_quantity: +formData?.request_quantity || 0,
                                        approved_quantity: +formData?.approved_quantity || 0,
                                        total_tranfer_quantity: +formData?.total_tranfer_quantity || 0,
                                    }
                                    if (RequestItemId !== null) {
                                        let DataList = [...IndentDataList]
                                        DataList[RequestItemId] = IndentData
                                        setIndentDataList(DataList)
                                        setRequestItemId(null)
                                    } else {
                                        let DataList = [...IndentDataList, IndentData]
                                        setIndentDataList(DataList)
                                    }
                                    setFormData({
                                        product_details: null,
                                        department_details: null,
                                        category_details: null,
                                        sub_category_details: null,
                                        product_type_details: null,
                                        modelSerialNo: "",
                                        hsnCode: "",
                                        quantity: "",
                                        selected_batch_list: [],
                                        available_batch_list: [],
                                    });
                                }
                            }}>Add</Button>
                        </Box>
                    </AccordionDetails>
                </Accordion>
                <Box sx={{ height: "100%", marginTop: "20px" }}>
                    {rendertable()}
                </Box>
            </Box>
            {isloader ? <Loader loaderOpen={isloader} /> : null}
            {console.log(IndentDataList)}
            {(errorMsg && errorMsgText) ?
                <ToastMsg
                    severity={'error'}
                    msg={errorMsgText}
                    msgPop={msgClose.bind(this)}
                />
                : null}
            {(successMsg && successMsgText) ?
                <ToastMsg
                    severity={'success'}
                    msg={successMsgText}
                    msgPop={msgClose.bind(this)}
                />
                : null}
        </Box>
    );
};

export default StoreIndentRiseAdd;
